import React, { useEffect, useState } from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import Chart from "react-apexcharts";
import {
  localGetMenu,
  localGetRefreshToken,
  localRemoveMenu,
  localRemoveRefreshToken,
  localRemoveToken,
  localSaveRefreshToken,
  localSaveToken,
} from "../../../utils/localStorage";
import { useNavigate } from "react-router-dom";
import { notifyError, notifyWarning } from "../../../components/notification";
import { api } from "../../../services/api/api.index";
import { API_URL } from "../../../services/api/config";
import { AiOutlineUser } from "react-icons/ai";
const ChartBottomRight = () => {
  const [dataSource, setDataSource] = useState([]);
  const [newData, setNewData] = useState([]);

  const [total, setTotal] = useState([]);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const getData = async () => {
    setLoading(true);
    setDataSource([]);
    try {
      let { data } = await api.get(
        `${API_URL}api/v1/reports/affiliation-client-report`
      );
      setLoading(false);
      setDataSource([
        { name: "Dưới link:", value: data?.count_affiliation },
        {
          name: "Không dưới link",
          value: data?.count_no_affiliation,
        },
      ]);
      setNewData(data);
    } catch (e) {
      if (e.statusCode === 401) {
        try {
          let { data } = await axios({
            method: "POST", //you can set what request you want to be
            url: `${API_URL}api/v1/auth/refresh-token`,
            headers: {
              Authorization: "Bearer " + localGetRefreshToken(),
            },
          });

          localSaveToken(data?.data?.accessToken);
          localSaveRefreshToken(data?.data?.refreshToken);
          getData();
        } catch (e) {
          navigate("/login");

          localRemoveRefreshToken();
          localRemoveToken();
          localRemoveMenu();
        }
      } else if (e.statusCode === 403) {
        navigate("/login");
        localRemoveRefreshToken();
        localRemoveToken();
        localRemoveMenu();
      } else {
        if (e.statusCode < 500) {
          notifyWarning(e.message);
        } else {
          notifyError("Chức năng đang bảo trì vui lòng thử lại sau.");
        }
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const RADIAN = Math.PI / 180;
  const COLORS = ["rgb(39,99,244)", "rgb(239,27,27)"];

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-(midAngle ?? 0) * RADIAN);
    const y = cy + radius * Math.sin(-(midAngle ?? 0) * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
        style={{ fontSize: "12px" }}
      >
        {`${((percent ?? 1) * 100).toFixed(2)}%`}
      </text>
    );
  };
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            background: "#fff",
            padding: "12px",
            borderRadius: "4px",
          }}
        >
          <p
            className="label"
            style={{ fontSize: "14px" }}
          >{`${payload[0].name} : ${payload[0].value}`}</p>
        </div>
      );
    }
    return null;
  };
  return (
    <div
      style={{
        background: "#fff",
        padding: "8px",
        borderRadius: "8px",
        position: "relative",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <p
          style={{
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            marginLeft: "16px",
          }}
        >
          <AiOutlineUser size={24} />
          &nbsp;Số lượng khách hàng
        </p>
      </div>
      <div
        style={{
          width: "100%",
          textAlign: "center",
          fontSize: "18px",
          fontWeight: "bold",
        }}
      >
        Tổng số lượng khách: {`${newData?.count_all}`} khách
      </div>
      <div
        style={{
          position: "absolute",
          top: "60px",
          left: "24px",
          display: "flex",
          height: "calc(100% - 140px)",
          flexFlow: "column",
          justifyContent: "space-between",
          fontSize: "14px",
        }}
      >
        <div
          style={{
            fontSize: "26px",
            fontWeight: "bold",
          }}
        >
          {total}
        </div>
        <div>Dưới link:</div>

        <div
          style={{
            color: "rgb(39,99,244)",
            fontSize: "20px",
            fontWeight: "bold",
          }}
        >
          {newData?.count_affiliation}&nbsp;
          <span style={{ fontSize: "16px" }}>
            (&nbsp;
            {newData?.affiliation_percentage}% )
          </span>
        </div>
        <div>Không dưới link:</div>
        <div
          style={{
            color: "rgb(239,27,27)",
            fontSize: "20px",
            fontWeight: "bold",
          }}
        >
          {newData?.count_no_affiliation}&nbsp;
          <span style={{ fontSize: "16px" }}>
            (&nbsp;
            {newData?.no_affiliation_percentage}% )
          </span>
        </div>
      </div>
      <div style={{ width: "100%", height: 350 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart width={400} height={400}>
            <Pie
              data={dataSource}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={renderCustomizedLabel}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >
              {dataSource.map((entry, index) => (
                <Cell
                  key={`cell-${entry.name}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ChartBottomRight;
